import { Ring } from './Ring'
import type { LevelMeta } from '../logic/types'

interface Props {
  level: LevelMeta
  mastered: number
  total: number
  onClick: () => void
}

export function LevelCard({ level, mastered, total, onClick }: Props) {
  const full = mastered >= total && total > 0
  const frac = total > 0 ? mastered / total : 0
  return (
    <button
      className={`level-card${full ? ' done' : ''}`}
      onClick={onClick}
      aria-label={`Niveau ${level.level} — ${mastered} из ${total} освоено`}
    >
      <Ring fraction={frac} full={full} />
      <div className="level-main">
        <div className="level-name">
          <span className="nm">{level.name}</span>
          <span className="cefr">{level.cefr}</span>
        </div>
        <div className="level-desc">{level.descRu}</div>
      </div>
      <div className="level-count">{mastered}/{total}</div>
      <svg className="chev" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" aria-hidden>
        <path d="m9 5 7 7-7 7" />
      </svg>
    </button>
  )
}
